export const LoadingView = () => (
  <div className="absolute inset-0 z-20 flex items-center justify-center bg-white bg-opacity-60">
    <span
      className="box-border inline-block h-10 w-10 animate-spin rounded-[50%] border-[5px] border-solid border-gray-200 border-b-sky-700"
      role="progressbar"
    />
  </div>
);
